var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"padding":"40px"}},[_c('h5',[_c('b',[_vm._v("LIST OF DELIVERY ORDER")])]),_c('hr'),_c('TableDeliveryOrderIndex',{attrs:{"fields":_vm.fields.fields,"filter":this.filter,"page":this.page,"date":this.date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }